module.exports = "/assets/2e83a1557f335a7cc199be67408c8513.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XK.png
// module id = 3117
// module chunks = 0